export const CONTENT_INFO_AUTHORS = 'authors';

export const CONTENT_INFO_DEPARTMENT = 'department';

export const CONTENT_INFO_LANGUAGE = 'language';

export const CONTENT_INFO_PRICE = 'price';
export const CONTENT_INFO_PRICE_TREND = 'priceTrend';

export const CONTENT_INFO_PUBLIC_ID = 'publicId';

export const CONTENT_INFO_PUBLICATION_DATE = 'publicationDate';
export const CONTENT_INFO_PUBLICATION_NAME = 'publicationName';
export const CONTENT_INFO_PUBLICATION_NAME_COUNTRY = 'publicationNameCountry';

export const CONTENT_INFO_SALES_COUNT = 'salesCount';

export const CONTENT_INFO_SIZE = 'size';

export const CONTENT_INFO_TREND_MATCH = 'trendMatch';

export const CONTENT_INFO_WORD_COUNT = 'wordCount';



export const CONTENT_INFOS = [
    CONTENT_INFO_AUTHORS,
    CONTENT_INFO_DEPARTMENT,
    CONTENT_INFO_LANGUAGE,
    CONTENT_INFO_PRICE,
    CONTENT_INFO_PRICE_TREND,
    CONTENT_INFO_PUBLIC_ID,
    CONTENT_INFO_PUBLICATION_DATE,
    CONTENT_INFO_PUBLICATION_NAME,
    CONTENT_INFO_PUBLICATION_NAME_COUNTRY,
    CONTENT_INFO_SALES_COUNT,
    CONTENT_INFO_SIZE,
    CONTENT_INFO_TREND_MATCH,
    CONTENT_INFO_WORD_COUNT
];
